import { useGetDraftReferralRequestsQuery } from '../../generated/home';

const useDraftReferralRequests = () => {
  const [{ data, fetching, error }] = useGetDraftReferralRequestsQuery({ requestPolicy: 'cache-and-network' });

  return { draftReferralRequests: data?.getDraftReferralRequests ?? [], fetching, error };
};

export { useDraftReferralRequests };
